import { v4 as uuidv4 } from 'uuid';

import { AnalyticsV2Event, TelemetryEventType } from '../../events';

import { formatTimestamp } from './formatTimestamp';
import { getClientId } from './getClientId';
import { getNetworkId } from './getNetworkId';
import { getTypeUrl } from './getTypeUrl';
import { getUserId } from './getUserId';
import { getWebClientType } from './getWebClientType';
import { loadProtobuf } from './lazyExports';

export interface AnalyticsV2EventProps {
  readonly packageName: string;
  readonly eventName: string;
  readonly value: Uint8Array;
}

type CreateAnalyticsV2Event = (props: AnalyticsV2EventProps) => Promise<AnalyticsV2Event | undefined>;
export const createAnalyticsV2Event: CreateAnalyticsV2Event = async ({ packageName, eventName, value }) => {
  const { base64 } = await loadProtobuf();
  const timestamp = Date.now();
  const webClientType = await getWebClientType();

  const clientId = getClientId();
  const networkId = getNetworkId();
  const userId = getUserId();

  if (clientId === undefined || networkId === undefined || userId === undefined) {
    return undefined;
  }

  const ev: AnalyticsV2Event = {
    type: TelemetryEventType.AnalyticsV2,
    name: eventName,
    occurredAt: timestamp.toString(),
    properties: {
      clientId,
      ecsEtag: '',
      eventId: uuidv4(),
      networkId,
      timestamp: formatTimestamp(timestamp),
      userAgent: '',
      userId,
      typeUrl: getTypeUrl(packageName, eventName),
      webClientType,
      value: base64.encode(value, 0, value.length),
    },
  };

  return ev;
};
